"use client";

import { useState } from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { LogOut } from "lucide-react";

type SignOutConfirmDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void | Promise<void>;
  confirming?: boolean;
};

export function SignOutConfirmDialog({
  open,
  onOpenChange,
  onConfirm,
  confirming = false,
}: SignOutConfirmDialogProps) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-2xl matte-metal border border-border bg-card/95">
        <div className="absolute inset-0 bg-gradient-to-br from-card/90 via-card/90 to-card/80 rounded-2xl -z-10" />
        <div className="absolute inset-0 bg-gradient-to-r from-y/5 via-transparent to-y/5 rounded-2xl -z-10" />
        <AlertDialogHeader>
          <AlertDialogTitle className="display text-lg uppercase tracking-tight">
            Sign Out
          </AlertDialogTitle>
          <AlertDialogDescription className="text-xs text-muted-foreground font-medium">
            Are you sure you want to sign out? You will need to authenticate
            again to access your academic workspace.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-xl text-xs font-black uppercase tracking-wider">
            Cancel
          </AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={confirming}
            className="rounded-xl bg-red-600 text-white hover:bg-red-600/90 text-xs font-black uppercase tracking-wider"
          >
            {confirming ? (
              "Signing out…"
            ) : (
              <span className="inline-flex items-center gap-2">
                <LogOut size={14} /> Sign Out
              </span>
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
